import { useState } from "react";
import { useLocation } from "wouter";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { CHECKIN_RETURN_KEY } from "@/lib/checkin";

// Check-in step 2 sends the hotel here with a session flag, because the OAuth round trip drops query
// parameters (plan Rev. 3 item 29). While the flag is set, offer the way back on top.
export function CheckinReturnBar() {
  const [, setLocation] = useLocation();
  const [show] = useState(() => {
    try { return window.sessionStorage.getItem(CHECKIN_RETURN_KEY) === "1"; } catch { return false; }
  });
  if (!show) return null;
  const back = () => {
    try { window.sessionStorage.removeItem(CHECKIN_RETURN_KEY); } catch { /* ignore */ }
    setLocation("/check-in");
  };
  return (
    <div className="mb-6 flex items-center justify-between gap-3 rounded-lg border border-green-200 bg-green-50 px-4 py-3" data-testid="bar-checkin-return">
      <span className="text-sm text-green-900">Sobald Instagram oder Facebook verbunden ist, geht es im Check-In weiter.</span>
      <Button size="sm" onClick={back} data-testid="button-checkin-return">
        <ArrowLeft className="mr-1 h-4 w-4" aria-hidden="true" />
        Zurück zum Check-In
      </Button>
    </div>
  );
}
